import { toast } from "react-toastify";
import {
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
} from "../actionTypes/actionTypes";
import axiosInstance from "../../axios/axios.instance";

/* istanbul ignore next */
export const loginUser = (userInfo: any) => async (dispatch: any) => {
  try {
    dispatch({ type: USER_LOGIN_LOADING });

    const res = await axiosInstance.post(`/users/login`, userInfo);

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: res.data,
      error: null,
    });

    localStorage.setItem("userCredentials", JSON.stringify(res.data));
    toast.success(res.data.message);
  } catch (error: any) {
    toast.error(error.response.data.message);
    dispatch({ type: USER_LOGIN_FAIL, payload: error.response.data });
  }
};
